export default __webpack_public_path__ + "static/media/8.a2d6cf6d.png";